// config.ts

// Import environment-specific configurations
import * as devConfig from './env.dev';
import * as stagingConfig from './env.staging';
import * as prodConfig from './env.prod';

// Define a type for the configuration object
interface Config {
    VEHICLE_API_URL: string;
    RESERVATION_API_URL: string;
    APP_INSIGHTS_CONNECTION_STRING: string;
}

// SCOPE is set at build time, e.g. `VITE_SCOPE=Production npm run build`
const environment = import.meta.env.VITE_SCOPE || 'Dev';

let config: Config;
if (environment === 'Production') {
    config = prodConfig;
} else if (environment === 'Staging') {
    config = stagingConfig;
} else {
    config = devConfig;
}

// Export functions to access configuration values
export const getVehicleApiUrl = (): string => config.VEHICLE_API_URL;
export const getReservationApiUrl = (): string => config.RESERVATION_API_URL;
export const getAppInsightsConnectionString = (): string => config.APP_INSIGHTS_CONNECTION_STRING;
